import React, { useState } from 'react';
import { useWindowSize } from 'react-use';

import useModal from '../../hooks/useModal';
import useStaticHeader from './utils/useStaticHeader';
import useEventListeners from './utils/useEventListeners';

import Icon from '../../molecules/Icon';
import SiteSearch from '../SiteSearch';
import LanguageSwitcher from '../LanguageSwitcher';
import CallToAction from '../CallToAction';

import MobileToggle from './components/MobileToggle';
import Navigation from './components/Navigation';
import MobileNavigation from './components/MobileNavigation';
import UpKeepLogo from './components/UpKeepLogo';

import { breakpointNumbers } from '../../atoms/breakpoints';

import headerTheme from './utils/headerTheme';
import {
  Buttons,
  Container,
  Header,
  Logo,
  PrimaryContent,
  SearchToggle,
  SecondaryContent,
  Wrapper,
} from './styles/index.styled';
import useElementHeight from '../../hooks/useElementHeight';
import UpKeepIntelligenceLogo from './components/UpKeepIntelligenceLogo';

const HeaderComponent = ({ theme, component }) => {
  const { openModal } = useModal();
  const { width } = useWindowSize();
  const staticData = useStaticHeader();
  const announcementBarHeight = useElementHeight({
    elementId: 'announcement-bar',
  });

  const [activeMenu, setActiveMenu] = useState(null);

  const initialTheme = theme || 'Fill - Light';

  const headerData = component || staticData;
  const { xl, lg } = breakpointNumbers;

  const {
    headerLogo,
    navItems,
    primaryButton,
    secondaryButton,
    showSearch,
    showLocaleToggle,
  } = headerData;

  const {
    activeTheme,
    mobileNavActive,
    setMobileNavActive,
    scrolled,
  } = useEventListeners(initialTheme, activeMenu);

  const handleDropdownClick = index => {
    if (activeMenu === index) {
      setActiveMenu(null);
    } else {
      setActiveMenu(index);
    }
  };

  return (
    <>
      <SiteSearch />
      <Header announcementBarHeight={announcementBarHeight}>
        <Container
          theme={activeTheme}
          activeMenu={activeMenu}
          mobileNavActive={mobileNavActive}
          scrolled={scrolled}
          className="exit"
        >
          <Wrapper>
            <PrimaryContent>
              {headerLogo === 'upkeep' && (
                <Logo
                  to="/"
                  aria-label="Go to Home Page"
                  width={132}
                  height={34}
                >
                  <UpKeepLogo theme={headerTheme[activeTheme].logo} />
                </Logo>
              )}
              {headerLogo === 'upkeep-intelligence' && (
                <Logo
                  to="/"
                  aria-label="Go to Home Page"
                  width={278}
                  height={36}
                >
                  <UpKeepIntelligenceLogo
                    theme={headerTheme[activeTheme].logo}
                  />
                </Logo>
              )}
              {width >= xl && (
                <Navigation
                  theme={headerTheme[activeTheme].text}
                  navItems={navItems}
                  activeMenu={activeMenu}
                  handleDropdownClick={handleDropdownClick}
                />
              )}
            </PrimaryContent>
            <SecondaryContent>
              {showSearch && (
                <SearchToggle onClick={() => openModal()} aria-label="Search">
                  <Icon
                    id="search-lg"
                    width={20}
                    height={20}
                    strokeColor={headerTheme[activeTheme].icon}
                  />
                </SearchToggle>
              )}
              {width < xl && showLocaleToggle && (
                <LanguageSwitcher theme={headerTheme[activeTheme].icon} />
              )}
              {width >= lg && (
                <Buttons>
                  {primaryButton && (
                    <CallToAction
                      variant={headerTheme[activeTheme].link}
                      {...primaryButton}
                    />
                  )}
                  {secondaryButton && (
                    <CallToAction
                      {...secondaryButton}
                      variant="Filled - Blue"
                      size="lg"
                    />
                  )}
                </Buttons>
              )}
              {width >= xl && showLocaleToggle && (
                <LanguageSwitcher theme={headerTheme[activeTheme].icon} />
              )}
              {width < xl && (
                <MobileToggle
                  theme={headerTheme[activeTheme].icon}
                  mobileNavActive={mobileNavActive}
                  setMobileNavActive={setMobileNavActive}
                />
              )}
            </SecondaryContent>
          </Wrapper>
        </Container>
        {width < xl && (
          <MobileNavigation
            navItems={navItems}
            primaryButton={primaryButton}
            secondaryButton={secondaryButton}
            mobileNavActive={mobileNavActive}
            activeMenu={activeMenu}
            handleDropdownClick={handleDropdownClick}
          />
        )}
      </Header>
    </>
  );
};

export default HeaderComponent;
